import styled from '@emotion/styled'
import { tokens } from '@news-mono/design-tokens'
import { UserSettingsButtonProps } from './UserSettingsButton'
import { breakpoint, calcRem, fonts, metrics } from '../../__styling'

// TheNightly Colors
const tnColors = tokens.thenightly.colors
const tnPalette = tnColors.palette
// TheNightly Metrics
const tnMetrics = metrics.thenightly
const tnMargins = tnMetrics.margins

// PerthNow Colors
const pnColors = tokens.perthnow.colors
const pnPalette = pnColors.palette

export interface StyledUserSettingsButtonProps
    extends UserSettingsButtonProps {}

export const StyledUserSettingsButton = styled(
    'button',
)<StyledUserSettingsButtonProps>(({ btnType, disabled = false, theme }) => [
    {
        fontFamily: theme.fonts.sansSerif,
        border: 'none',
        background: disabled
            ? getColorMap(theme.kind)[btnType].disabled
            : getColorMap(theme.kind)[btnType].default,
        color:
            btnType === 'muted'
                ? getColorMap(theme.kind).primary.default
                : tnPalette.white,
        padding: calcRem(tnMargins.sm2l, tnMargins.m2l),
        borderRadius: '8px',
        fontWeight: 600,
        lineHeight: '150%',
        cursor: disabled ? 'no-drop' : 'pointer',
        marginLeft: calcRem(tnMargins.sm),
        textTransform: 'uppercase',

        '&:focus, &:hover, &:active': {
            background: disabled
                ? getColorMap(theme.kind)[btnType].disabled
                : getColorMap(theme.kind)[btnType].active,
        },
    },
    // PerthNow Styling
    theme.kind === 'perthnow' && {
        marginLeft: 0,
        padding: calcRem(8, 24),
        height: calcRem(48),

        lineHeight: calcRem(16),
        fontSize: calcRem(16),
        fontWeight: 600,

        textTransform: 'none',

        // Mobile styling
        width: '100%',

        // Tablet styling
        [breakpoint('sm')]: {
            width: 'auto',
        },
    },
])

const getColorMap = (
    kind: string,
): Record<
    StyledUserSettingsButtonProps['btnType'],
    { default: string; disabled: string; active: string }
> => {
    // Button styling for PerthNow
    if (kind === 'perthnow') {
        return {
            primary: {
                default: pnPalette.pinkThulite,
                active: pnPalette.pinkGarnet,
                disabled: pnPalette.pinkThuliteShade[50],
            },
            danger: {
                default: pnPalette.redCrisis[600],
                disabled: pnPalette.redCrisis[50],
                active: pnPalette.redCrisis[650],
            },
            muted: {
                default: 'transparent',
                disabled: 'transparent',
                active: pnPalette.blackShade[4],
            },
        }
    }

    // Button styling for TheNightly
    return {
        primary: {
            active: tnPalette.uplate.default,
            default: tnPalette.uplate.default,
            disabled: tnPalette.uplate.light,
        },
        danger: {
            active: tnPalette.utility.error.default,
            default: tnPalette.utility.error.default,
            disabled: tnPalette.utility.error.light,
        },
        muted: {
            default: tnPalette.white,
            disabled: tnPalette.white,
            active: tnPalette.white,
        },
    }
}
